export default __webpack_public_path__ + "/dist/images/app-mockup.97bc2b62b71324412a6711279d8a52d4.png";